import { PopOver } from "../../components/atoms";
import { JsonViewer } from "../../components/molecules";
import { whiteCopyIcon, whiteTickIcon } from "../../assets/icons";
import { useState } from "react";
import classNames from "classnames";

const CollectionCard = ({ schema, name, popOverOptions, onClick }) => {
  const [shouldShowTickOnCopy, setShouldShowTickOnCopy] = useState(false);

  const handleCopyToClipboard = () => {
    if (navigator.clipboard)
      navigator.clipboard.writeText(JSON.stringify(schema)).then(() => {
        setShouldShowTickOnCopy(true);
        setTimeout(() => setShouldShowTickOnCopy(false), 1000);
      });
  };

  return (
    <div
      className="col-span-12 sm:col-span-6 xl:col-span-4 bg-gray-800 rounded-lg overflow-hidden relative hover:shadow-lg hover:bg-gray-700/75 hover:scale-[1.02] hover:duration-100"
      onClick={onClick}
    >
      <div className="block rounded-lg shadow-lg">
        <div
          className="py-3 px-6 border-b bg-gray-800 text-gray-50 border-gray-800 flex items-center justify-between"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="flex flex-row space-x-2">
            <div className="text-left whitespace-pre">{name}</div>
          </div>
          <div className="inline-block justify-end flex">
            <div>
              <button
                className="w-7 h-7 rounded-full grid place-items-center hover:bg-gray-700/50"
                onClick={handleCopyToClipboard}
              >
                <img
                  src={shouldShowTickOnCopy ? whiteTickIcon : whiteCopyIcon}
                  className={classNames({
                    "w-4": !shouldShowTickOnCopy,
                    "w-5": shouldShowTickOnCopy,
                  })}
                  alt={shouldShowTickOnCopy ? "tick-icon" : "copy-icon"}
                />
              </button>
            </div>
            <PopOver options={popOverOptions} />
          </div>
        </div>
        <div className="p-2 h-60 lg:h-80 overflow-auto bg-neutral-900 no-scrollbar">
          <JsonViewer value={schema} className="leading-snug tracking-tight" />
        </div>
      </div>
    </div>
  );
};
export default CollectionCard;
